"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARAM_KEY = exports.ADDON_ID = void 0;
exports.ADDON_ID = 'addon-launchdarkly';
exports.PARAM_KEY = 'launchdarkly';
//# sourceMappingURL=constants.js.map